import React from 'react';
import Container from '../UI/Container/Container';
import './Header.css';
import tsgLogo from '../../images/logo.png';

const Header = () => {
    return(
        <Container>
            <div className="tsg-header-container">
                <div className="tsg-image-container">
                    <img className="tsg-image" src={tsgLogo} alt=""/>
                </div>
                <h1 className="tsg-htitle">Carbon footprint calculator</h1>
            </div>    
        </Container>
    );
}

export default Header;
